module.exports = __webpack_public_path__ + "static/media/38-4.3a45a619.mp3";